export const CATEGORIES = [
  { id: 'furniture', label: 'Furniture', emoji: '🛋️' },
  { id: 'removals', label: 'Removals', emoji: '📦' },
  { id: 'cars', label: 'Cars', emoji: '🚗' },
  { id: 'motorcycles', label: 'Motorcycles & Scooters', emoji: '🏍️' },
  { id: 'pallets', label: 'Pallets', emoji: '📦' },
  { id: 'freight', label: 'Freight', emoji: '🚛' },
  { id: 'parcels', label: 'Parcels', emoji: '📪' },
  { id: 'machinery', label: 'Machinery & Equipment', emoji: '⚙️' },
  { id: 'other_vehicles', label: 'Other Vehicles', emoji: '🚜' },
  { id: 'pets', label: 'Pets', emoji: '🐕' },
  { id: 'building_materials', label: 'Building Materials', emoji: '🧱' },
  { id: 'fragile', label: 'Fragile Goods', emoji: '🔮' },
  { id: 'boats', label: 'Boats', emoji: '⛵' },
  { id: 'bicycles', label: 'Bicycles', emoji: '🚲' },
  { id: 'vehicle_parts', label: 'Vehicle Parts', emoji: '🔩' },
  { id: 'household', label: 'Household Appliances', emoji: '🏠' },
  { id: 'other', label: 'Other', emoji: '📦' },
];

export const mapTemplateTitleToTranslation = (title, t) => {
  if (typeof title !== 'string') {
    console.warn('Invalid title:', title);
    return '';
  }

  const lowerTitle = title.toLowerCase();

  if (!lowerTitle.endsWith(' transport')) {
    return title;
  }

  // Take everything before the last word ("transport")
  const prefix = lowerTitle.slice(0, lowerTitle.lastIndexOf(' ')).trim();

  // Convert spaces to underscores to match category IDs
  const normalizedPrefix = prefix.replace(/\s+/g, '_');

  const categoryData = CATEGORIES.find(
    (cat) => cat.id === normalizedPrefix
  );

  const categoryKey = categoryData?.id || normalizedPrefix;

  return t('category_transport', {
    category: t(categoryKey),
  });
};